export default {
  title: "Проверьте <br /> вашу почту",
  closeBtn: "Закрыть"
};
